import {
  ArrowsAltOutlined,
  BellOutlined,
  BugOutlined,
  ChromeOutlined,
  DropboxOutlined,
  ExpandOutlined,
  EyeOutlined,
  MedicineBoxOutlined,
  MoonOutlined,
  ShakeOutlined,
  WindowsOutlined
} from '@ant-design/icons';
import { Typography } from 'antd';
import React from 'react';
import { useI18n } from '../i18n';

const { Title, Paragraph, Text } = Typography;

const SymptomsPage: React.FC = () => {
  const { t } = useI18n();

  // 症状数据配置
  const symptoms = [
    {
      icon: <WindowsOutlined style={{ fontSize: '32px', color: '#1890ff' }} />,
      title: t('symptoms.commonProblems.items.nasalCongestion.title'),
      description: t('symptoms.commonProblems.items.nasalCongestion.description')
    },
    {
      icon: <DropboxOutlined style={{ fontSize: '32px', color: '#1890ff' }} />,
      title: t('symptoms.commonProblems.items.postNasalDrip.title'),
      description: t('symptoms.commonProblems.items.postNasalDrip.description')
    },
    {
      icon: <ExpandOutlined style={{ fontSize: '32px', color: '#52c41a' }} />,
      title: t('symptoms.commonProblems.items.turbinateHypertrophy.title'),
      description: t('symptoms.commonProblems.items.turbinateHypertrophy.description')
    },
    {
      icon: <ArrowsAltOutlined style={{ fontSize: '32px', color: '#faad14' }} />,
      title: t('symptoms.commonProblems.items.deviatedSeptum.title'),
      description: t('symptoms.commonProblems.items.deviatedSeptum.description')
    },
    {
      icon: <MedicineBoxOutlined style={{ fontSize: '32px', color: '#f5222d' }} />,
      title: t('symptoms.commonProblems.items.postSurgicalCare.title'),
      description: t('symptoms.commonProblems.items.postSurgicalCare.description')
    },
    {
      icon: <ShakeOutlined style={{ fontSize: '32px', color: '#1890ff' }} />,
      title: t('symptoms.commonProblems.items.dryRhinitis.title'),
      description: t('symptoms.commonProblems.items.dryRhinitis.description')
    },
    {
      icon: <BugOutlined style={{ fontSize: '32px', color: '#52c41a' }} />,
      title: t('symptoms.commonProblems.items.infectiousRhinitis.title'),
      description: t('symptoms.commonProblems.items.infectiousRhinitis.description')
    },
    {
      icon: <EyeOutlined style={{ fontSize: '32px', color: '#1890ff' }} />,
      title: t('symptoms.commonProblems.items.eyeNoseAllergy.title'),
      description: t('symptoms.commonProblems.items.eyeNoseAllergy.description')
    },
    {
      icon: <BugOutlined style={{ fontSize: '32px', color: '#faad14' }} />,
      title: t('symptoms.commonProblems.items.nasalCough.title'),
      description: t('symptoms.commonProblems.items.nasalCough.description')
    },
    {
      icon: <BellOutlined style={{ fontSize: '32px', color: '#f5222d' }} />,
      title: t('symptoms.commonProblems.items.sleepApnea.title'),
      description: t('symptoms.commonProblems.items.sleepApnea.description')
    },
    {
      icon: <MoonOutlined style={{ fontSize: '32px', color: '#1890ff' }} />,
      title: t('symptoms.commonProblems.items.occupationalRhinitis.title'),
      description: t('symptoms.commonProblems.items.occupationalRhinitis.description')
    },
    {
      icon: <ChromeOutlined style={{ fontSize: '32px', color: '#52c41a' }} />,
      title: t('symptoms.commonProblems.items.vasomotorRhinitis.title'),
      description: t('symptoms.commonProblems.items.vasomotorRhinitis.description')
    }
  ];

  return (
    <div>
      <section style={{ width: '100%', lineHeight: 0, margin: 0, padding: 0 }}>
        <img src={'/img/phone/31.jpg'} style={{ width: '100%', display: 'block', margin: 0 }} alt="spacing" />
      </section>
    </div>
  );
};

export default SymptomsPage;
